// @flow
import { Capacitor } from "@capacitor/core";
import { Share } from "@capacitor/share";
import * as React from 'react';
import { Helmet } from "react-helmet";
import useCalculationForm from "../../hooks/useCalculationForm";
import { FormikProvider, ErrorMessage } from "formik";
import MainCard from "../../../../theme/mantis/components/mainCard";
import { getRouteUrl } from "../../../../helpers/getRouteUrl";
import { ROUTE_PAGE_HOME, ROUTE_PAGE_LOGIN } from "../../../../routers/routes";
import { useTranslation } from "react-i18next";
import { CALCULATIONS } from "../../locales/namespaces";
import { ROUTE_PAGE_CALCULATIONS_INDEX, ROUTE_PAGE_CALCULATIONS_CREATE } from "../../routes/routes";
import {
	Box, Button, FormControl, FormControlLabel,
	Stack, RadioGroup, Radio, Toolbar, Divider, Typography, AccordionSummary, Accordion,
	AccordionDetails, useMediaQuery, Grid, useTheme, Switch, TextField, DialogContent, Dialog, FormHelperText
} from "@mui/material";
import { Link, useHistory } from "react-router-dom";
import LinesChart from "../charts/linesChart/linesChart";
import BarsChart from "../charts/barsChart/barsChart";

import { useEffect, useState, useRef } from "react";
import RepaymentsForm from "../repaymentsForm/repaymentsForm";
import RepaymentsList from "../repaymentsList/repaymentsList";
import moment from "moment";
import FixedTable from "../tables/fixedTable";
import FloatTable from "../tables/floatTable";
import { calculateInstallments } from "../../helpers/calculations";
import AlertDialogForResetForm from "../deleteRepaymentsResetFormDialog/deleteRepaymentsResetFormDialog";

import { useLocation } from "react-router";
import InputsCalculation from '../inputsCalculation/inputsCalculation'

import useUserData from "../../../../hooks/user/useUserData";
import { enqueueSnackbar } from "notistack";
import ContentLoader from "../../../../components/contentLoader/contentLoader";
import { NumericFormat } from "react-number-format";

import HelpCircleIcon from "../../../../assets/images/icons/buttonsIcons/helpCircleIcon";
import Sending from "../../../../assets/images/icons/buttonsIcons/sending";
import ShareCalculations from "../../../../assets/images/icons/shareCalculations";
import Delete from "../../../../assets/images/icons/buttonsIcons/delete";
import Copy from "../../../../assets/images/icons/buttonsIcons/copy";
import Save from "../../../../assets/images/icons/buttonsIcons/save";
import ArrowLeftIcon from "../../../../assets/images/icons/buttonsIcons/arrowLeftIcon";
import Arrow from "../../../../assets/images/icons/buttonsIcons/arrow";
import AlertMessageForSimpleUser
	from "../../../customers/components/alertMessageForSimpleUser/alertMessageForSimpleUser";
import PlusIcon from "../../../../assets/images/icons/buttonsIcons/plusIcon";


import usePopover from "../../hooks/usePopover";

import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import ButtonGroup from '@mui/material/ButtonGroup';
import SupportDialog from "../../../../pages/supportDialog/supportDialog";
import SendingCalculationPopup from './sendingCalculationPopup'


type Props = {
	id: string,
	calculations?: Object,
	contributions: Array,
	interests: Array,
	openRepaymentsTable: Boolean,
	setOpenRepaymentsTable: Function,
}

const CalculationForm = (props: Props) => {
	const { t } = useTranslation(CALCULATIONS)
	const location = useLocation()
	const { decimalSeparator, thousandSeparator, isLoggedIn } = useUserData()
	const [openRepayments, setOpenRepayments] = useState(false);
	//const [expanded, setExpanded] = useState(false);
	const [expandedIn, setExpandedIn] = useState(true);
	const [expandedInTables, setExpandedInTables] = useState(true);
	const [expandedInCharts, setExpandedInCharts] = useState(true);
	const [openReset, setOpenReset] = useState(false);
	const [copyDescription, setCopyDescription] = useState('');
	const history = useHistory()
	const [popoverId, setPopoverId] = useState('')
	const [isOpenDesc, setIsOpenDesc] = useState(false);
	const repaymentsListRef = useRef(null);

	// const [openRepaymentsTable, setOpenRepaymentsTable] = useState(false);

	const [openCopy, setOpenCopy] = useState(false);

	const buttons = [
		{ label: t('Save'), color: 'info' },
		{ label: t("Share"), color: 'warning' },
		{ label: t('Help'), color: 'warning' },
		{ label: t('Reset'), color: 'warning' },
		{ label: t('Copy'), color: 'error' },

	];

	const [open, setOpen] = useState(false);
	const anchorRef = useRef(null);
	const [anchorMobile, setAnchorMobile] = useState(null);
	const [selectedIndex, setSelectedIndex] = useState(0);
	const [openSendingCalculation, setOpenSendingCalculation] = useState(false);
	const [linkSending, setLinkSending] = useState('');
	const [linkUrlFast, setLinkUrlFast] = useState('');

	const isCreatePage = location.pathname === '/calculations/create';


	const handleClickMobile = (event) => {
		setAnchorMobile(anchorMobile ? null : event.currentTarget);
		setOpen((prevOpen) => !prevOpen);
	};

	const handleMenuItemClick = async (event, index) => {



		if (index === 0) {
			await formik.submitForm();
		} else if (index === 1) {
			sendingCalculationForm();
		} else if (index === 2) {
			setIsOpenDesc(true)
			handlePopoverId('description');
		} else if (index === 3) {
			if (id && repayments.length > 0) {
				handleClickOpenReset();
			} else {
				handleResetForm();
			}
		} else if (index === 4) {
			setOpenCopy(true);
		} 
		





		setAnchorMobile(anchorMobile ? null : event.currentTarget);
		setSelectedIndex(index);
		setOpen(false);
	};


	const handleClose = (event) => {
		setOpen(false);
	};

	const {
		id,
		calculations,
		interests,
		contributions,
		repayments,
		updateRepayments,
		handleUpdateRepayments,
		handleRemoveRepayment,
		repaymentsLoading,
		openRepaymentsTable,
        setOpenRepaymentsTable,
	} = props

	useEffect(() => {
		if (openRepaymentsTable && repaymentsListRef.current) {
			repaymentsListRef.current.scrollIntoView({
				behavior: "auto",
				block: "start"     
			});
		}
	}, [openRepaymentsTable]);

	const {
		formik,
		results,
		TotalDuration,
		InstallmentNumber,
		handleDate,
		handleResults,
		handleInterestType,
		handleCalculateInstallments,
		handleCalculationsLoanAmount,
		handleCalculationsRealEstateValue,
		handleResetForm,
		isLoading
	} = useCalculationForm({
		id,
		calculations,
		interests,
		contributions,
		repayments
	})

	const {
		handleAnchorElClick,
		handleAnchorElClose,
		openAnchorEl,
		anchorEl
	} = usePopover()

	const isMobile = useMediaQuery('(max-width:800px)');
	const matchDownSM = useMediaQuery((theme) => theme.breakpoints.down('sm'));
	const matchDownMd = useMediaQuery((theme) => theme.breakpoints.down('md'));

	const columns = [
		{ field: 'id', hide: true, headerName: t('N/A'), width: 110 },
		{ field: 'Date', headerName: t('Payment date'), width: 200 },
		{
			field: 'installment',
			headerName: formik.values.isMonthly === 'isMonthly' ? t('Monthly Installment') : t('Yearly Installment'),
			width: 160,
			renderCell: ({ row }) => {
				return row.installment ? <NumericFormat
					thousandSeparator={thousandSeparator}
					decimalSeparator={decimalSeparator}
					displayType="text"
					value={row.installment}
				/> : 0
			}
		},
		{
			field: 'interest', headerName: t('Interest'), width: 120,
			renderCell: ({ row }) => {
				return row.interest ? <NumericFormat
					thousandSeparator={thousandSeparator}
					decimalSeparator={decimalSeparator}
					displayType="text"
					value={row.interest}
				/> : 0
			}
		},
		{
			field: 'creolysio', headerName: t('Amortization'), width: 150,
			renderCell: ({ row }) => {
				return row.creolysio ? <NumericFormat
					thousandSeparator={thousandSeparator}
					decimalSeparator={decimalSeparator}
					displayType="text"
					value={row.creolysio}
				/> : 0
			}
		},
		{
			field: 'remainingAmount', headerName: t('Remaining Principal'), width: 220,

			renderCell: ({ row }) => {
				return row.remainingAmount ? <NumericFormat
					thousandSeparator={thousandSeparator}
					decimalSeparator={decimalSeparator}
					displayType="text"
					value={row.remainingAmount}
				/> : 0
			}
		},
		{
			field: 'sumInterest', headerName: t('Total Interest'), width: 180,
			renderCell: ({ row }) => {
				return row.sumInterest ? <NumericFormat
					thousandSeparator={thousandSeparator}
					decimalSeparator={decimalSeparator}
					displayType="text"
					value={row.sumInterest}
				/> : 0
			}
		},
		{
			field: 'repayment', headerName: t('Total principal repayment'), width: 250,
			renderCell: ({ row }) => {
				return row.repayment ? <NumericFormat
					thousandSeparator={thousandSeparator}
					decimalSeparator={decimalSeparator}
					displayType="text"
					value={row.repayment}
				/> : 0
			}
		},
	];

	const columnsMobile = [
		{ field: 'id', hide: true, headerName: t('N/A'), width: 80 },
		{ field: 'Date', headerName: t('Payment date'), width: 150 },
		{
			field: 'installment',
			headerName: formik.values.isMonthly === 'isMonthly' ? t('Monthly Installment') : t('Yearly Installment'),
			width: 120,
			renderCell: ({ row }) => {
				return row.installment ? <NumericFormat
					thousandSeparator={thousandSeparator}
					decimalSeparator={decimalSeparator}
					displayType="text"
					value={row.installment}
				/> : 0
			}
		},
		{
			field: 'remainingAmount', headerName: t('Remaining Principal'), width: 150,
			renderCell: ({ row }) => {
				return row.remainingAmount ? <NumericFormat
					thousandSeparator={thousandSeparator}
					decimalSeparator={decimalSeparator}
					displayType="text"
					value={row.remainingAmount}
				/> : 0
			}
		},
		{
			field: 'sumInterest', headerName: t('Total Interest'), width: 120,
			renderCell: ({ row }) => {
				return row.sumInterest ? <NumericFormat
					thousandSeparator={thousandSeparator}
					decimalSeparator={decimalSeparator}
					displayType="text"
					value={row.sumInterest}
				/> : 0
			}
		},
		{
			field: 'repayment', headerName: t('Total principal repayment'), width: 160,
			renderCell: ({ row }) => {
				return row.repayment ? <NumericFormat
					thousandSeparator={thousandSeparator}
					decimalSeparator={decimalSeparator}
					displayType="text"
					value={row.repayment}
				/> : 0
			}
		},
	];

	const rowsFixed = results && results.FixedTable ? results.FixedTable.map((row, index) => ({
		id: index + 1,
		creolysio: Math.max(row.Creolysio, 0).toFixed(2),
		installment: Math.max(row.Installment, 0).toFixed(2),
		interest: Math.max(row.Interest, 0).toFixed(2),
		remainingAmount: Math.max(row.RemainingAmount, 0).toFixed(2),
		repayment: Math.max(row.Repayment, 0).toFixed(2),
		sumInterest: Math.max(row.SumInterest, 0).toFixed(2),
		Date: row.Date,
		isRepayment: row.isRepayment
	})) : [];

	console.log(rowsFixed);
	

	const rowsFloat = results && results.FloatTable ? results.FloatTable.map((row) => ({
		id: row.AA,
		creolysio: Math.max(row.Creolysio, 0).toFixed(2),
		installment: Math.max(row.Installment, 0).toFixed(2),
		interest: Math.max(row.Interest, 0).toFixed(2),
		remainingAmount: Math.max(row.RemainingAmount, 0).toFixed(2),
		repayment: Math.max(row.Repayment, 0).toFixed(2),
		sumInterest: Math.max(row.SumInterest, 0).toFixed(2),
		Date: row.Date,
		isRepayment: row.isRepayment
	})) : [];

	/*const handleAccordionChange = (panel) => (event, isExpanded) => {
		setExpanded(isExpanded ? panel : false);
	};*/
	const handleAccordionChangeIn = () => {
		setExpandedIn(!expandedIn);
	};
	const handleAccordionChangeInTables = () => {
		setExpandedInTables(!expandedInTables);
	};
	const handleAccordionChangeInCharts = () => {
		setExpandedInCharts(!expandedInCharts);
	};

	const onCloseRepayments = () => {
		setOpenRepayments(false)
	}

	const handleClickOpenReset = () => {
		setOpenReset(true);
	};

	const handleCloseReset = () => {
		setOpenReset(false);
	};

	const mapRepayments = repayments.map(repayment => ({
		Amount: Number(repayment.Amount),
		NewRate: Number(repayment.NewRate),
		Repayment_dt: moment(repayment.PaymentDt).format('MM/DD/YYYY')
	}))

	//call calculateInstallments with isMonthly === false, so I have the data in yearly mode for diagrams
	const chartData = calculateInstallments(
		0,
		formik.values.FixedDuration,
		formik.values.FloatingDuration,
		formik.values.FixedInterestRate,
		Number(formik.values.Spread) + Number(formik.values.Euribor),
		contributions.find(f => f.id === formik.values.Contribution)?.Value,
		formik.values.LoanAmount,
		false,
		formik.values.isHidePreviousInstallments,
		moment(formik.values.DateInstallment).format('MM/DD/YYYY'),
		[...mapRepayments],
		[],
		[],
		0,
		0,
		0,
		0,
		[...mapRepayments])

	const kpiData = calculateInstallments(
		1,
		formik.values.FixedDuration,
		formik.values.FloatingDuration,
		formik.values.FixedInterestRate,
		Number(formik.values.Spread) + Number(formik.values.Euribor),
		contributions.find(f => f.id === formik.values.Contribution)?.Value,
		formik.values.LoanAmount,
		true,
		formik.values.isHidePreviousInstallments,
		moment(formik.values.DateInstallment).format('MM/DD/YYYY'),
		[...mapRepayments],
		[],
		[],
		0,
		0,
		0,
		0,
		[...mapRepayments])

	const fixed = kpiData && kpiData.FixedTable ? kpiData.FixedTable.map((row) => ({
		id: row.AA,
		creolysio: Math.max(row.Creolysio, 0).toFixed(2),
		installment: Math.max(row.Installment, 0).toFixed(2),
		interest: Math.max(row.Interest, 0).toFixed(2),
		remainingAmount: Math.max(row.RemainingAmount, 0).toFixed(2),
		repayment: Math.max(row.Repayment, 0).toFixed(2),
		sumInterest: Math.max(row.SumInterest, 0).toFixed(2),
		Date: row.Date,
		isRepayment: row.isRepayment
	})) : [];

	const float = kpiData && kpiData.FloatTable ? kpiData.FloatTable.map((row) => ({
		id: row.AA,
		creolysio: Math.max(row.Creolysio, 0).toFixed(2),
		installment: Math.max(row.Installment, 0).toFixed(2),
		interest: Math.max(row.Interest, 0).toFixed(2),
		remainingAmount: Math.max(row.RemainingAmount, 0).toFixed(2),
		repayment: Math.max(row.Repayment, 0).toFixed(2),
		sumInterest: Math.max(row.SumInterest, 0).toFixed(2),
		Date: row.Date,
		isRepayment: row.isRepayment
	})) : [];

	//concat data for Calculations Diagrams to show them in one diagram
	const FinalTable = (chartData.FixedTable?.concat(chartData.FloatTable)) || [];

	const handleClick = () => {
		//When the anonymous user clicks the button to show interest for a loan request
		enqueueSnackbar(<AlertMessageForSimpleUser />, {
			variant: 'info',
			hideIconVariant: true,
			autoHideDuration: 4000,
		}
		)

	}

	const handleInterestedLoanUnAuth = () => {
		enqueueSnackbar(t('To apply for a loan you must have an account.'), {
			variant: 'info'
		}
		)
		history.push(getRouteUrl(ROUTE_PAGE_LOGIN))
	}

	const handlePopoverId = (id) => {
		setPopoverId(id)
	}
	useEffect(() => {
		handleAnchorElClick(popoverId)
	}, [popoverId])

	useEffect(() => {
		if (matchDownMd) {
			const element = document.getElementById(popoverId)
			if (element) {
				element.scrollIntoView({
					behavior: 'smooth',
					block: 'center',
				});
			}
		}
	}, [popoverId]);


	const theme = useTheme();
	const matchBetweenXSSM = useMediaQuery('@media (min-width:0px) and (max-width:998px)');


	const generateQueryString = (values) => {
		const params = new URLSearchParams();
		Object.entries(values).forEach(([key, value]) => {
			if (typeof value === 'object') {
				params.append(key, JSON.stringify(value));
			} else {
				params.append(key, value);
			}
		});
		if (Array.isArray(repayments) && repayments.length > 0) {
			params.append('repayments', JSON.stringify(repayments));
		}
		return params.toString();
	};


	const sendingCalculationForm = () => {
		debugger
		const queryString = generateQueryString(formik.values);
		let baseUrlFast = `${window.location.origin}/fast/calculation`;
		let shareUrlFast = `${baseUrlFast}?${queryString}`;
		console.log(shareUrlFast, 'window = ', window.location.origin, 'hostname = ',window.location.hostname)
		if(Capacitor.isNativePlatform()) {
			if(Capacitor.getPlatform() === 'ios'){
				const prefix = process.env.NODE_ENV === 'production' ? 'https://': 'http://';
				baseUrlFast = `${prefix}${window.location.hostname}/fast/calculation`;
				shareUrlFast = `${baseUrlFast}?${queryString}`
			}
			Share.share({
				url: shareUrlFast
			}).then(res => {
				console.log('SHARE RES', res)
			}).catch(error => {
				console.log('SHARE ER', error)
			})
		} else {
			// fallback function
			const fallbackCopyTextToClipboard = (text) => {
				const textArea = document.createElement("textarea");
				textArea.value = text;
				textArea.style.position = "fixed";  // αποφυγή scrolling
				textArea.style.top = "-9999px";
				textArea.style.left = "-9999px";
				document.body.appendChild(textArea);
				textArea.focus();
				textArea.select();
				
				let successful = false;
				try {
					successful = document.execCommand('copy');
				} catch (err) {
					successful = false;
				}
				document.body.removeChild(textArea);
				enqueueSnackbar(
					successful ? t("Link copied to clipboard") : t("Failed to copy link"),
					{ variant: successful ? "success" : "error" }
				);
			};
			
			// Κύρια λογική με έλεγχο αν υπάρχει το Clipboard API
			if (navigator.clipboard && navigator.clipboard.writeText) {
				navigator.clipboard.writeText(shareUrlFast)
				.then(() => {
					enqueueSnackbar(t("Link copied to clipboard"), { variant: "success" });
				})
				.catch(() => {
					fallbackCopyTextToClipboard(shareUrlFast);
				});
			} else {
				fallbackCopyTextToClipboard(shareUrlFast);
			}
		}
	};




	const selectOptionsMenu = () => {
		return (
			<Stack
				direction={{ xs: 'column', sm: 'row', md: 'row', lg: 'row', xl: 'row' }}
				spacing={1}
				sx={{ padding: '10px' }}
			>
				<FormControl variant="standard" fullWidth sx={{ mt: 4 }}>
					<Stack direction={{ xs: 'column', sm: 'row', md: 'row', lg: 'row', xl: 'row' }}>
						<RadioGroup
							row
							aria-labelledby="row-radio-buttons-group-label"
							name="isMonthly"
							value={formik.values.isMonthly}
							onChange={handleCalculateInstallments}
							className="flex-nowrap"
							sx={{
								overflowX: 'auto',
								whiteSpace: 'nowrap',
								flexWrap: 'nowrap',
								WebkitOverflowScrolling: 'touch',
								scrollbarWidth: 'none',
								'&::-webkit-scrollbar': {
									display: 'none',
								},
							}}
						>
							{openRepaymentsTable && (
								<Button
									color="info"
									variant="outlined"
									size="small"
									sx={{ padding: '6px 10px !important', marginRight: '10px', fontSize: '12px !important', whiteSpace: 'nowrap', flexShrink: 0,minWidth: 'fit-content' 
									 }}
									onClick={() => setOpenRepaymentsTable(false)}
								>
									<ArrowLeftIcon style={{ width: '18px' }} /> {t('Return')}
								</Button>
							)}

							{((!(location.pathname === '/fast/calculation')) && !isCreatePage) && (
								<Button
									color="info"
									variant="contained"
									size="small"
									sx={{ padding: '10px 10px', marginRight: '10px', fontSize: '12px', whiteSpace: 'nowrap', flexShrink: 0,minWidth: 'fit-content'  }}
									onClick={() => {
										openRepaymentsTable
											? setOpenRepayments(true)
											: setOpenRepayments(false);
										setOpenRepaymentsTable(true);
									}}
								>
									<PlusIcon /> { openRepaymentsTable ?  t("Repayment") :  t("Repayments")}
								</Button>
							)}

							{(  location.pathname === '/fast/calculation' ) && (
								<Button
									color="info"
									variant="contained"
									size="small"
									sx={{ padding: '10px 10px', marginRight: '10px', fontSize: '12px', whiteSpace: 'nowrap', flexShrink: 0,minWidth: 'fit-content'  }}
									onClick={() => {
										openRepaymentsTable
											? setOpenRepayments(true)
											: setOpenRepayments(false);
										setOpenRepaymentsTable(true);
									}}
								>
									<PlusIcon /> { openRepaymentsTable ?  t("Repayment") :  t("Repayments")}
								</Button>
							)}

							{!openRepaymentsTable && (
								<>
									<FormControlLabel
										value="isYearly"
										sx={{ whiteSpace: 'nowrap', flexShrink: 0,minWidth: 'fit-content', marginLeft:'2px'}}
										control={
											<Radio
												size="small"
												sx={{
													'& .dot': {
														backgroundColor: '#485476',
														width: '22px !important',
														height: '22px !important',
														top: '0px !important',
														left: '0px !important'
													}
												}}
											/>
										}
										label={t("Yearly")}
									/>
									<FormControlLabel
										value="isMonthly"
										sx={{ whiteSpace: 'nowrap', flexShrink: 0,minWidth: 'fit-content'}}
										control={
											<Radio
												size="small"
												sx={{
													'& .dot': {
														backgroundColor: '#485476',
														width: '22px !important',
														height: '22px !important',
														top: '0px !important',
														left: '0px !important'
													}
												}}
											/>
										}
										label={t("Monthly")}
									/>
									<FormControlLabel
										sx={{ whiteSpace: 'nowrap', flexShrink: 0,minWidth: 'fit-content'}}
										control={
											<Switch
												checked={formik.values.isHidePreviousInstallments}
												onChange={handleCalculateInstallments}
												onBlur={formik.handleBlur}
												name="isHidePreviousInstallments"
												sx={{
													'.MuiSwitch-thumb::before': {
														display: 'none'
													},
													'.MuiSwitch-thumb': {
														backgroundColor: 'white'
													},
													'& .MuiSwitch-track': {
														backgroundColor: '#485476'
													}
												}}
											/>
										}
										label={t("Hide previous installments")}
									/>
								</>
							)}
						</RadioGroup>
					</Stack>
				</FormControl>
			</Stack>
		);
	};

	const copyCalculation = () => {
		history.push({
			pathname: getRouteUrl(ROUTE_PAGE_CALCULATIONS_CREATE),
			search: `?id=${id}&Description=${encodeURIComponent(copyDescription)}`,
		});
		setOpenCopy(false);
	};



	return !isLoading ? (
		<>
			<FormikProvider value={formik}>
				<Helmet>
					<title>{t("IMS Financial Consulting | Mortgage Calculator")}</title>
					<meta name="description"
						content={t("Use our mortgage calculator to estimate your monthly payments and find the best loan options. Trusted mortgage solutions by IMS Financial Consulting.")} />
					<meta name="author" content="IMS Financial Consulting" />
					<meta name="robots" content="index, follow" />
					{/* Open Graph / Facebook */}
					<meta property="og:type" content="website" />
					<meta property="og:url" content="https://app.ims-fc.gr/fast/calculation" />
					<meta property="og:title" content={t("IMS Financial Consulting | Mortgage Calculator")} />
					<meta property="og:description"
						content={t("Estimate your mortgage payments with our calculator. Get accurate results and explore the best mortgage options available in Greece.")} />
					<meta property="og:image" content="https://www.ims-fc.gr/images/mortgage-calculator.png" />
					{/* Twitter */}
					<meta name="twitter:card" content="summary_large_image" />
					<meta name="twitter:url" content="https://app.ims-fc.gr/fast/calculation" />
					<meta name="twitter:title" content={t("IMS Financial Consulting | Mortgage Calculator")} />
					<meta name="twitter:description"
						content={t("Quickly calculate your mortgage payments and discover the best loan options with IMS FC mortgage calculator.")} />
					<meta name="twitter:image" content="https://www.ims-fc.gr/images/mortgage-calculator.png" />
				</Helmet>


				<Box>
					<Grid container alignItems="center" justifyContent="space-between"
						sx={{
							margin: {
								xs: '10px 0',
								sm: '30px 0',
								md: '30px 0',
							},
						}}

					>
						<Grid item xs={3} sm={3} md={3} lg={4}>
							<Typography className='title-xsm color-default'
								sx={{
									marginLeft:'12px',
									fontSize: {
										xs: '18px !important'
									}
								}}
							>
								{t('Loan criteria')}
							</Typography>
						</Grid>
						{expandedIn &&
							<Grid item xs={9} sm={9} md={9} lg={8} >
								{(location.pathname === '/calculations/create' || location.pathname === ('/calculations/edit/' + id)) ?
									<div style={{ display: 'flex', justifyContent: 'flex-end' }}>
										<Grid container spacing={1} justifyContent="flex-end">
											<Grid item>
												{matchBetweenXSSM ?
													<>

														<ButtonGroup
															variant="outlined"
															ref={anchorRef}
															sx={{
																'button, a': {
																	padding: { xs: '10px 11px' },
																	'&:hover': {
																		borderColor: '#cdcdcd',
																	},
																}
															}}
														>
															<Button size={'small'} variant={'outlined'}  onClick={handleClickMobile} sx={{ padding: '4px' }}>
																<Arrow />
															</Button>




															{selectedIndex === 0 && (
																<Button
																	size={"small"}
																	variant={"outlined"}
																	sx={{ gap: '8px', minWidth: '150px' }}
																	onClick={(event) => {
																		event.stopPropagation()
																		formik.submitForm()
																	}}
																>
																	<Save /> {t('Save')}
																</Button>
															)}






															{selectedIndex === 1 && (
																<Button
																	size={'small'}
																	variant={'outlined'}
																	sx={{ gap: '8px', minWidth: '150px' }}
																	id="help-button"
																	onClick={(event) => {
																		event.stopPropagation();
																		sendingCalculationForm()
																	}}
																>
																	<ShareCalculations /> {t("Share")}
																</Button>
															)}

															{selectedIndex === 2 && (
																<Button
																	size={'small'}
																	variant={'outlined'}
																	sx={{ gap: '8px', minWidth: '150px' }}
																	id="help-button"
																	onClick={(event) => {
																		event.stopPropagation();
																		setIsOpenDesc(true)
																		handlePopoverId('description')
																	}}
																>
																	<HelpCircleIcon />{t('Help')}
																</Button>
															)}

															{selectedIndex === 3 && (
																<Button
																	size={"small"}
																	variant={"outlined"}
																	sx={{ gap: '8px', minWidth: '150px' }}
																	onClick={(event) => {
																		event.stopPropagation()
																		if (id && repayments.length > 0) {
																			handleClickOpenReset()
																		} else {
																			handleResetForm()
																		}
																	}}
																>
																	<Delete /> {t('Reset')}
																</Button>
															)}

															{selectedIndex === 4 && (
																<Button
																	size={"small"}
																	variant={"outlined"}
																	onClick={(event) => {
																		event.stopPropagation()
																		setOpenCopy(true)
																	}}
																	sx={{
																		gap: '8px', minWidth: '150px',
																		'&.Mui-disabled': {
																			borderRadius: '0'

																		}
																	}}
																	disabled={!id}
																>
																	<Copy /> {t('Copy')}
																</Button>
															)}


														</ButtonGroup>


														<Popper
															sx={{ zIndex: 1 }}
															open={open}
															anchorEl={anchorMobile}
															role={undefined}
															transition
															disablePortal
														>
															{({ TransitionProps, placement }) => (
																<Grow
																	{...TransitionProps}
																	style={{
																		transformOrigin:
																			placement === 'bottom' ? 'center top' : 'center bottom',
																	}}
																>
																	<Paper>
																		<ClickAwayListener onClickAway={handleClose}>
																			<MenuList id="split-button-menu" autoFocusItem>
																				{buttons.map((option, index) => (
																					<MenuItem
																						key={option.label}
																						disabled={index === selectedIndex}
																						selected={index === selectedIndex}
																						onClick={(event) => handleMenuItemClick(event, index)}
																					>
																						{option.label}
																					</MenuItem>
																				))}
																			</MenuList>
																		</ClickAwayListener>
																	</Paper>
																</Grow>
															)}
														</Popper>
													</>
													:
													<>
														<ButtonGroup variant="outlined" aria-label="Basic button group"
															sx={{
																'button, a': {
																	'&:hover': {
																		borderColor: '#cdcdcd',
																	},
																}
															}}
														>
															<Button
																size={'small'}
																variant={'outlined'}
																sx={{ gap: '8px', minWidth: '150px' }}
																id="help-button"
																onClick={(event) => {
																	event.stopPropagation();
																	sendingCalculationForm()
																}}
															>
																<ShareCalculations /> {t("Share")}
															</Button>

															<Button
																size={'small'}
																variant={'outlined'}
																sx={{ gap: '8px', minWidth: '150px' }}
																id="help-button"
																onClick={(event) => {
																	event.stopPropagation();
																	setIsOpenDesc(true)
																	handlePopoverId('description')
																}}
															>
																<HelpCircleIcon />{t('Help')}
															</Button>

															<Button
																size={"small"}
																variant={"outlined"}
																sx={{ gap: '8px', minWidth: '150px' }}
																onClick={(event) => {
																	event.stopPropagation()
																	if (id && repayments.length > 0) {
																		handleClickOpenReset()
																	} else {
																		handleResetForm()
																	}
																}}
															>
																<Delete /> {t('Reset')}
															</Button>

															<Button
																size={"small"}
																variant={"outlined"}
																onClick={(event) => {
																	event.stopPropagation()
																	setOpenCopy(true)
																}}
																sx={{
																	gap: '8px', minWidth: '150px',
																	'&.Mui-disabled': {
																		borderRadius: '0'

																	}
																}}
																disabled={!id}
															>
																<Copy /> {t('Copy')}
															</Button>

															<Button
																size={"small"}
																variant={"outlined"}
																sx={{ gap: '8px', minWidth: '150px' }}
																onClick={(event) => {
																	event.stopPropagation()
																	formik.submitForm()
																}}
															>
																<Save /> {t('Save')}
															</Button>

														</ButtonGroup>

													</>
												}



											</Grid>

										</Grid>
									</div>
									:
									location.pathname === '/fast/calculation' &&
									<div style={{ display: 'flex', justifyContent: 'flex-end' }}>
										{/* <Button
												size={'small'}
												variant={'outlined'}
												sx={{ gap: '8px', minWidth: '150px' }}
												id="help-button"
												onClick={(event) => {
													event.stopPropagation();
													sendingCalculationForm()
												}}
											>
												<ShareCalculations /> {t("Share")}
											</Button>
										<Button size={"small"} variant={"outlined"} color={'blue'}
											onClick={id && repayments.length > 0 ? handleClickOpenReset : handleResetForm}
											sx={{ float: 'right' }}>
											{t('Reset')}
										</Button> */}















											<Grid item>
												{matchBetweenXSSM ?
													<>

														<ButtonGroup
															variant="outlined"
															ref={anchorRef}
															sx={{
																'button, a': {
																	padding: { xs: '10px 11px' },
																	'&:hover': {
																		borderColor: '#cdcdcd',
																	},
																}
															}}
														>
															<Button size={'small'} variant={'outlined'}  onClick={handleClickMobile} sx={{ padding: '4px' }}>
																<Arrow />
															</Button>

															{selectedIndex === 0 && (
																<Button
																	size={'small'}
																	variant={'outlined'}
																	sx={{ gap: '8px', minWidth: '150px' }}
																	id="help-button"
																	onClick={(event) => {
																		event.stopPropagation();
																		sendingCalculationForm()
																	}}
																>
																	<ShareCalculations /> {t("Share")}
																</Button>
															)}

															{selectedIndex === 1 && (
																<Button size={"small"} variant={"outlined"} color={'blue'}
																	onClick={id && repayments.length > 0 ? handleClickOpenReset() : handleResetForm()}
																	sx={{ float: 'right' }}>
																	{t('Reset')}
																</Button>
															)}


					

														</ButtonGroup>


														<Popper
															sx={{ zIndex: 1 }}
															open={open}
															anchorEl={anchorMobile}
															role={undefined}
															transition
															disablePortal
														>
															{({ TransitionProps, placement }) => (
																<Grow
																	{...TransitionProps}
																	style={{
																		transformOrigin:
																			placement === 'bottom' ? 'center top' : 'center bottom',
																	}}
																>
																	<Paper>
																		<ClickAwayListener onClickAway={handleClose}>
																			<MenuList id="split-button-menu" autoFocusItem>
																				{buttons.map((option, index) => (
																					<MenuItem
																						key={option.label}
																						disabled={index === selectedIndex}
																						selected={index === selectedIndex}
																						onClick={(event) => handleMenuItemClick(event, index)}
																					>
																						{option.label}
																					</MenuItem>
																				))}
																			</MenuList>
																		</ClickAwayListener>
																	</Paper>
																</Grow>
															)}
														</Popper>
													</>
													:
													<>
														<ButtonGroup variant="outlined" aria-label="Basic button group"
															sx={{
																'button, a': {
																	'&:hover': {
																		borderColor: '#cdcdcd',
																	},
																}
															}}
														>
															<Button
																size={'small'}
																variant={'outlined'}
																sx={{ gap: '8px', minWidth: '150px' }}
																id="help-button"
																onClick={(event) => {
																	event.stopPropagation();
																	sendingCalculationForm()
																}}
															>
																<ShareCalculations /> {t("Share")}
															</Button>
													

															<Button size={"small"} variant={"outlined"} color={'blue'}
																onClick={id && repayments.length > 0 ? handleClickOpenReset : handleResetForm}
																sx={{ float: 'right' }}>
																{t('Reset')}
															</Button>


														</ButtonGroup>

													</>
												}



											</Grid>














									</div>
								}
							</Grid>
						}
					</Grid>
					<Box className="calculation-form">
						<InputsCalculation
							formik={formik}
							handleCalculationsRealEstateValue={handleCalculationsRealEstateValue}
							handleCalculationsLoanAmount={handleCalculationsLoanAmount}
							handleInterestType={handleInterestType}
							handleCalculateInstallments={handleCalculateInstallments}
							contributions={contributions}
							handleDate={handleDate}
							location={location}
							id={id}
							rowsFixed={rowsFixed}
							rowsFloat={rowsFloat}
							float={float}
							fixed={fixed}
							TotalDuration={TotalDuration}
							InstallmentNumber={InstallmentNumber}
							handleInterestedLoanUnAuth={handleInterestedLoanUnAuth}
							handleClick={handleClick}
							handleAnchorElClick={handleAnchorElClick}
							openAnchorEl={openAnchorEl}
							anchorEl={anchorEl}
							handleAnchorElClose={handleAnchorElClose}
							popoverId={popoverId}
							handlePopoverId={handlePopoverId}
							isOpenDesc={isOpenDesc}
							setIsOpenDesc={setIsOpenDesc}
						/>
					</Box>
					<div ref={repaymentsListRef}></div>
					<AlertDialogForResetForm
						openReset={openReset}
						handleCloseReset={handleCloseReset}
						id={id}
						handleResetForm={handleResetForm}
						updateRepayments={updateRepayments}
						handleUpdateRepayments={handleUpdateRepayments}
					/>
					{/* {isMobile ?} */}
					{/* <>
							<Typography variant={'h4'} component={'div'}
								fontWeight={400}>
									{t('Loan Calculation Tables')}
							</Typography>


							<Box sx={{ mt: 1, mb: 1, ml: 1 }}>
								<Stack direction={'column'}>
									<FormControl variant="standard" fullWidth>
										<RadioGroup
											row
											aria-labelledby="row-radio-buttons-group-label"
											name="isMonthly"
											value={formik.values.isMonthly}
											onChange={handleCalculateInstallments}
										>
											<FormControlLabel
												value="isYearly"
												control={
													<Radio
														color={'info'}
														size={'small'}
													/>
												}
												label={t("Yearly")}
											/>
											<FormControlLabel
												value="isMonthly"
												control={
													<Radio
														color={'info'}
														size={'small'}
													/>
												}
												label={t("Monthly")}
											/>
										</RadioGroup>
									</FormControl>
									<Box>
										<FormControl variant="standard" fullWidth sx={{ mt: 2 }}>
											<FormControlLabel
												control={
													<StyleSwitch
														checked={formik.values.isHidePreviousInstallments}
														onChange={handleCalculateInstallments}
														onBlur={formik.handleBlur}
														size={'medium'}
														name={'isHidePreviousInstallments'}
													/>
												}
												label={t('Hide previous installments')}
												labelPlacement="end"
											/>
										</FormControl>
									</Box>
								</Stack>
								<Stack
									direction={{ xs: 'column', sm: 'column', md: 'column', lg: 'column', xl: 'row' }}
									spacing={3}>
									{rowsFixed.length > 0 &&
										(
											<Box className={'customer-index'}>
												<Divider sx={{ mb: 2 }} light />
												<Toolbar disableGutters variant={"dense"}>
													<Typography variant="bodyMedium" gutterBottom sx={{ ml: 2 }}>
														{t('Fixed rate Installments')}
													</Typography>
												</Toolbar>
												<Divider sx={{ mb: 2 }} light />
												<DataGridWrapper
													sx={{
														mt: 1,
														height: '400px'
													}}
												>
													<StyledDataGrid
														getRowClassName={(params) => {
															return (
																params.row.isRepayment === 1 ? `super-app-theme--${params.row.isRepayment}` :
																	params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
															)
														}}
														disableColumnMenu={true}
														sx={{
															".MuiDataGrid-aggregationColumnHeaderLabel": {
																display: "none",
																'.MuiDataGrid-cellContent': {
																	fontWeight: 400
																}
															},
															"& .MuiDataGrid-columnHeader .MuiDataGrid-iconButtonContainer": {
																visibility: "visible",
																width: "auto"
															},
															"& .MuiDataGrid-columnHeader:not(.MuiDataGrid-columnHeader--sorted) .MuiDataGrid-sortIcon": {
																opacity: 0.5
															},
														}}
														slots={{
															columnUnsortedIcon: UnsortedIcon,
														}}
														rows={rowsFixed}
														columns={columnsMobile}
														localeText={muiGridLocales(t)}
													/>
												</DataGridWrapper>
											</Box>
										)
									}
									{rowsFloat.length > 0 &&
										(
											<Box className={'customer-index'}>
												<Divider sx={{ mb: 2 }} light />
												<Toolbar disableGutters variant={"dense"}>
													<Typography variant="bodyMedium" gutterBottom sx={{ ml: 2 }}>
														{t('Float rate Installments')}
													</Typography>
												</Toolbar>
												<Divider sx={{ mb: 2 }} light />
												<DataGridWrapper
													sx={{
														mt: 1,
														height: '400px'
													}}
												>
													<StyledDataGrid
														getRowClassName={(params) => {
															return (
																params.row.isRepayment === 1 ? `super-app-theme--${params.row.isRepayment}` :
																	params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
															)
														}}
														disableColumnMenu={true} rows={rowsFloat}
														columns={columnsMobile}
														sx={{
															".MuiDataGrid-aggregationColumnHeaderLabel": {
																display: "none"
															},
															'.MuiDataGrid-cellContent': {
																fontWeight: 400
															},
															"& .MuiDataGrid-columnHeader .MuiDataGrid-iconButtonContainer": {
																visibility: "visible",
																width: "auto"
															},
															"& .MuiDataGrid-columnHeader:not(.MuiDataGrid-columnHeader--sorted) .MuiDataGrid-sortIcon": {
																opacity: 0.5
															},
														}}
														slots={{
															columnUnsortedIcon: UnsortedIcon,
														}}
														localeText={muiGridLocales(t)}
													/>
												</DataGridWrapper>
											</Box>
										)
									}
								</Stack>
							</Box>


						</> */}

					<>
						<Box sx={{ mt: 1, mb: 1, ml: 1 }}>
							{((!(rowsFloat.length > 0 && rowsFixed.length <= 0) || openRepaymentsTable)) &&
								<Box>
									<Typography className='title-xsm color-default'
										sx={{
											margin: {
												xs: '30px 0 10px 0',
												sm: '50px 0 20px 0',
												md: '50px 0 20px 0',
											},
										}}
									>
										{!(rowsFloat.length > 0 && rowsFixed.length <= 0) ? t('Fixed rate Installments') : t('Float rate Installments')}
									</Typography>

									<Box sx={{ border: '0.6px solid #DAE0F0', borderRadius: '12px', backgroundColor: '#F5F7FC', overflow: 'hidden' }}>
										{selectOptionsMenu()}
										{openRepaymentsTable ?
											(
												<div >
													<RepaymentsForm
														id={id}
														open={openRepayments}
														onClose={onCloseRepayments}
														handleResults={handleResults}
														calculationData={formik.values}
														contributions={contributions}
														repayments={repayments}
														updateRepayments={updateRepayments}
														handleUpdateRepayments={handleUpdateRepayments}
													/>
													<RepaymentsList
														repayments={repayments}
														handleRemoveRepayment={handleRemoveRepayment}
														handleResults={handleResults}
														calculationData={formik.values}
														contributions={contributions}
														updateRepayments={updateRepayments}
														handleUpdateRepayments={handleUpdateRepayments}
													/>
												</div>
											)
											:
											(
												<Stack
													justifyContent="space-between"
													direction={{
														xs: 'column',
														sm: 'column',
														md: 'column',
														lg: 'column',
														xl: 'column'
													}}
													spacing={1}>
													{((rowsFixed.length > 0 && rowsFloat.length > 0) && !repaymentsLoading ) &&
														(
															<Box width={{
																lg: '100%',
																xl: '100%'
															}}>
																<FixedTable rowsFixed={rowsFixed} columns={columns} />
															</Box>
														)
													}
													{(rowsFixed.length > 0 && rowsFloat.length <= 0  && !repaymentsLoading ) &&
														(
															<Box width={{
																lg: '100%',
																xl: '100%'
															}}>
																<FixedTable rowsFixed={rowsFixed} columns={isMobile ? columnsMobile : columns} />
															</Box>
														)
													}

												</Stack>
											)
										}
									</Box>
								</Box>
							}

							{(!openRepaymentsTable  && !repaymentsLoading ) &&
								<Box>
									{((rowsFloat.length > 0 && rowsFixed.length > 0) || (rowsFloat.length > 0 && rowsFixed.length <= 0)) &&
										<Box>
											<Typography className='title-xsm color-default'
												sx={{
													margin: {
														xs: '30px 0 10px 0',
														sm: '50px 0 20px 0',
														md: '50px 0 20px 0',
													},
												}}>
												{t('Float rate Installments')}
											</Typography>
											<Box sx={{ border: '0.6px solid #DAE0F0', borderRadius: '12px', backgroundColor: '#F5F7FC', overflow: 'hidden' }}>
												{rowsFloat.length > 0 && rowsFixed.length <= 0 && selectOptionsMenu()}
												<Stack
													justifyContent="space-between"
													direction={{
														xs: 'column',
														sm: 'column',
														md: 'column',
														lg: 'column',
														xl: 'column'
													}}
													spacing={1}>
													<Box width={{
														lg: '100%',
														xl: '100%'
													}}>
														<FloatTable rowsFloat={rowsFloat} columns={columns} />
													</Box>
												</Stack>
											</Box>
										</Box>
									}
								</Box>

							}
						</Box>
					</>
					{(rowsFixed.length > 0 || rowsFloat.length > 0) && !repaymentsLoading &&
						(
							<>
								<Typography className='title-xsm color-default'
									sx={{
										margin: {
											xs: '30px 0 10px 0',
											sm: '50px 0 20px 0',
											md: '50px 0 20px 0',
										}
									}}
								>
									{t('Calculation Diagrams')}
								</Typography>
								<Grid container alignItems="center" spacing={2}>
									<Grid item xs={12} sm={12} md={6} lg={6}>
										<Box className='border-cnt' style={{ paddingTop: '10px' }}>
											<BarsChart results={chartData} FinalTable={FinalTable} />
										</Box>
									</Grid>
									<Grid item xs={12} sm={12} md={6} lg={6}>
										<Box className='border-cnt' style={{ paddingTop: '10px' }}>
											<LinesChart results={chartData} FinalTable={FinalTable} />
										</Box>
									</Grid>
								</Grid>

							</>

						)
					}

				</Box>
			</FormikProvider>




			<Dialog
				onClick={(e) => {
					e.stopPropagation()
				}}
				open={openCopy}
				sx={{

					'& .MuiPaper-root': {
						border: '0.6px solid #DAE0F0',
						borderRadius: '12px',
						margin: '0',
					},
					'.MuiBox-root': {
						color: '#485476',
						fontSize: '22px',
						fontWeight: '500'
					},
					p: '0 10px 0 10px',
					'& .MuiCardHeader-root': {
						padding: '20px 20px 0 20px',
						display: 'flex',
						flexDirection: 'row',
					},
					'& .MuiCard-root > .MuiDivider-root': {
						display: 'none',
					},
				}}
			>
				<MainCard
					withoutArrow={true}
					sx={{ maxWidth: '500px', overflow: 'auto', '& .MuiCardHeader-content .MuiTypography-root .MuiBox-root': { fontSize: { xs: '18px', sm: '20px' } } }}
					title={t('Copy')}
					secondary={
						<Box
							onClick={(e) => {
								e.stopPropagation()
								setOpenCopy(false)
							}}
							sx={{
								color: '#485476',
								fontSize: '13px !important',
								lineHeight: '14px',
								border: '0.6px solid #485476',
								borderRadius: '50%',
								height: '18px',
								width: '18px',
								textAlign: 'center',
								fontWeight: '600 !important'
							}}
						>
							x
						</Box>
					}
				>
					<Box>
						<DialogContent sx={{ p: 0 }}>
							<FormikProvider value={formik}>
								<Box sx={{ p: 0.5 }}>


									<Typography sx={{ margin: '0 0 10px', fontSize: { xs: '18px' } }} className='color-default'>
										{t('New calculation description prompt')}
									</Typography>

									<FormControl
										variant="standard"
										fullWidth
										error={copyDescription === ''}
									>
								
										<TextField
											sx={{ margin: '10px 0 20px 0' }}
											name="copyDescription"
											value={copyDescription}
											onChange={(e) => setCopyDescription(e.target.value)}
											color="grey"
											size="small"
											fullWidth
											inputProps={{ maxLength: 100 }}
											required
										/>

									</FormControl>


									<Button
										variant={"contained"}
										onClick={(event) => {
											event.stopPropagation()
											if (copyDescription !== '') {
												copyCalculation();
											}										}}
										sx={{
											textAlign:'center',
											padding: '10px 0',
											mb: '17px',
											width: '100%'
										}}
									>
										{t('Copy')}
									</Button>
								</Box>
							</FormikProvider>
						</DialogContent>
					</Box>
				</MainCard>
			</Dialog>










		</>
	) : (
		<ContentLoader
			withBackDrop={true}
			useCircularLoader={true}
			loading={isLoading}
			message={t("Loading... Please don't close the browser before the process ends.")}
		/>
	)
}

export default CalculationForm